// Token de sesion de usuario.
export interface Token {
  // jwt token.
  accessToken: string;

  // tipo de token. Bearer.
  tokenType: string;

  // Tiempo de expiracion del token.
  expiresIn: number;

  // Nombre completo del usuario.
  name: string;

  // URL del avatar del usuario.
  // En caso de no tener avatar, se devuelve la url del avatar por defecto.
  picture: string;

  // email del usuario.
  email: string;

  // Permisos del usuario.
  permissions: string[];

  // Indica si el proceso de 2fa esta habilitado para el sistema.
  // Si el 2fa esta habilitado, el usuario tiene que pasar por el flujo de 2fa.
  // Si el 2fa no esta habilitado, el usuario no tiene que pasar por el flujo de 2fa.
  is2faFlowEnabled: boolean;

  // Identificador del usuario.
  userId: string;
}

// Código de verificacion del 2fa.
// Este código es el que se envia al usuario por app.
// Se utilizan 2 códigos consecutivos para activar el 2fa del usuario.
export interface TurnOn {
  code1: string;
  code2: string;
}

// Código de verificacion del 2fa.
export interface Authenticte {
  code: string;
}

// Token de acceso del usuario.
// Este token es el que se guarda en el store que se persiste en el local storage del navegador.
export interface AccessToken {
  // Identificador del usuario.
  userId: string;

  // Email del usuario.
  email: string;

  // Listado de permisos del usuario.
  // De forma predeterminada vienen vacios.
  permissions: string[];

  // Indica que el usuario tiene habilitado el 2fa.
  // Si el 2fa esta habilitado, el usuario tiene que pasar por el flujo de 2fa.
  // Si el 2fa no esta habilitado, el usuario tiene habilitar el 2fa.
  is2faEnabled: boolean;

  // Indica si el usuario ya paso por el flujo de validación de 2fa.
  is2faValidated: boolean;
}

export function is2faFlowEnabled(token: Token): boolean {
  const rv =
    typeof token === 'object' &&
    token !== null &&
    'is2faFlowEnabled' in token &&
    typeof token.is2faFlowEnabled === 'boolean' &&
    token.is2faFlowEnabled;
  return rv;
}

export function is2faEnabled(token: AccessToken): boolean {
  const rv =
    typeof token === 'object' &&
    token !== null &&
    'is2faEnabled' in token &&
    typeof token.is2faEnabled === 'boolean' &&
    token.is2faEnabled;
  return rv;
}

export function is2faValidated(token: AccessToken): boolean {
  const rv =
    typeof token === 'object' &&
    token !== null &&
    'is2faValidated' in token &&
    typeof token.is2faValidated === 'boolean' &&
    token.is2faValidated;
  return rv;
}

export enum Errors {
  tokenExpired = 'token_expired',
  internalError = 'internal_error',
  invalidCode = 'invalid_code',
}
